var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    strokeWidth: 3,
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete-2--remove-bold-add-button-buttons-delete-cross-x-mathematics-multiply-math"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.994 43.053c-1.03.907-2.392 1.292-3.56.572-.735-.453-1.668-1.164-2.783-2.279-1.114-1.114-1.825-2.048-2.279-2.783-.72-1.168-.335-2.53.572-3.56 1.55-1.76 4.648-5.14 10.416-11.005-5.766-5.863-8.864-9.244-10.414-11.003-.907-1.03-1.292-2.392-.572-3.56.454-.735 1.165-1.668 2.28-2.783C7.767 5.538 8.7 4.827 9.436 4.373c1.167-.72 2.53-.335 3.559.572 1.76 1.55 5.14 4.648 11.003 10.414 5.863-5.766 9.244-8.864 11.004-10.414 1.03-.907 2.391-1.292 3.559-.572.735.454 1.669 1.165 2.783 2.28 1.115 1.114 1.826 2.047 2.28 2.783.72 1.167.334 2.53-.572 3.559-1.55 1.76-4.648 5.14-10.414 11.003 5.767 5.864 8.865 9.246 10.415 11.006.907 1.03 1.292 2.391.572 3.559-.453.735-1.164 1.669-2.279 2.783-1.114 1.115-2.048 1.826-2.784 2.28-1.167.72-2.53.334-3.558-.572-1.76-1.55-5.142-4.65-11.006-10.416-5.864 5.767-9.245 8.865-11.005 10.416Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.7a0843bac3bba6aee45c64c040de9b79.svg";
export { ForwardRef as ReactComponent };